import Vue from 'vue';

export const mutations = {
    setFreeze: (state, freeze) => {
        state.freeze = freeze
    },
    setFilterStateValue: (state, { filterName, value }) => {
        if (filterName === 'availability') {
            // Reset Selection :-o
            Vue.set(state, 'selectedFilterValues', {});
        }
        if (value === null) {
            Vue.delete(state.selectedFilterValues, filterName);
        }
        else {
            Vue.set(state.selectedFilterValues, filterName, value);
        }
        // Vue.set(state, "hash", helper.generateHash(state.filterStates));
    },
    setResults: (state, results) => {
        Vue.set(state, 'results', results);
    },
    appendResults: (state, results) => {
        Vue.set(state, 'results', state.results.concat(results));
    },
    setTotal: (state, total) => {
        state.totalResults = total;
    },
    setAvailableFilterValues: (state, filters) => {
        Vue.set(state, 'availableFilterValues', filters);
    },

    toggleFilters: (state) => {
        Vue.set(state, 'showFilters', !state.showFilters);
    }
};
